import React, { useState } from "react";

import { useDispatch } from "react-redux";
import { DialogContent, Grid, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";

import { Modal } from "../../../../HOC/modal";
import useStyles from "./SearchGames.styles";
import SearchModalContent from "./SearchModalContent";
import { resetSearchGames } from "../../../../redux-saga/redux/casino/lobby/casinoGames";

const SearchGames = () => {
  const classes = useStyles();
  const [showSearch, setShowSearch] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Grid>
      <Grid
        onClick={() => {
          dispatch(resetSearchGames());
          setShowSearch((prev) => !prev);
        }}
        display={"flex"}
        alignItems={"center"}
        gap={"10px"}
      >
        <Grid className={classes.searchField}>
          <SearchIcon style={{ fontSize: "18px", marginRight: "10px" }} />
          {t("COMMON.SEARCH_GAMES")}
        </Grid>
        <Box className={classes.searchIcon}>
          <Button>
            <SearchIcon />
          </Button>
        </Box>
      </Grid>
      <Modal
        isShowing={showSearch}
        className={classes.dialogcontainer}
        content={
          <DialogContent>
            <SearchModalContent setShowSearch={setShowSearch} />
          </DialogContent>
        }
        hide={() => {
          setShowSearch((prev) => !prev);
          dispatch(resetSearchGames());
        }}
      />
    </Grid>
  );
};

export default SearchGames;
